import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "app-background w-100" }
const _hoisted_2 = {
  key: 0,
  id: "private",
  class: "app-container container-large d-flex flex-column flex-xl-row"
}
const _hoisted_3 = { class: "d-flex flex-column order-2 order-xl-1 flex-xl-row align-items-start navbar-custome custom-h-100" }
const _hoisted_4 = { class: "flex-grow-1 order-1 order-xl-2 h-100 w-100" }
const _hoisted_5 = {
  key: 1,
  id: "public",
  class: "app-container container-small d-flex flex-column w-100"
}
const _hoisted_6 = { class: "position-relative w-100 p-5" }
const _hoisted_7 = { class: "order-1 order-xl-2 flex-grow-1 d-flex w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GlobalLoading = _resolveComponent("GlobalLoading")!
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _component_InstallPromptComponent = _resolveComponent("InstallPromptComponent")!
  const _component_OfflineModeComponent = _resolveComponent("OfflineModeComponent")!
  const _component_NavBarComponent = _resolveComponent("NavBarComponent")!
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_LecLogo = _resolveComponent("LecLogo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_GlobalLoading),
    _createVNode(_component_LoadingComponent),
    (!_ctx.isAndroidApp)
      ? (_openBlock(), _createBlock(_component_InstallPromptComponent, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.systemStore.maintenanceMode)
      ? (_openBlock(), _createBlock(_component_OfflineModeComponent, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.authStore.isLoggedIn && _ctx.$route.meta.requiresAuth)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_NavBarComponent, { id: "NavBarComponent" })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_RouterView, { name: "private" })
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_LecLogo, { "shrink-img": true })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_RouterView, {
                class: "router-view-padding px-3 pb-4 w-100 pt-0 pt-md-3 w-100",
                name: "public"
              })
            ])
          ]))
    ])
  ], 64))
}